var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormProcessing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93359 8.5H13.9336V10.5H2.93359V8.5ZM2.93359 6.5H13.9336V4.5H2.93359V6.5ZM2.93359 14.5H9.93359V12.5H2.93359V14.5ZM17.9436 11.37L18.6536 10.66C19.0436 10.27 19.6736 10.27 20.0636 10.66L20.7736 11.37C21.1636 11.76 21.1636 12.39 20.7736 12.78L20.0636 13.49L17.9436 11.37ZM17.2336 12.08L11.9336 17.38V19.5H14.0536L19.3536 14.2L17.2336 12.08Z",
    fill: "#00579C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormProcessing);
export default __webpack_public_path__ + "static/media/FormProcessing.6a22e256585eb2c8d130875bab0b4824.svg";
export { ForwardRef as ReactComponent };